// src/modules/app-views/products/pages/Document/tabs/SuppliersTab/modals/CostItemModal/Step1.jsx
// *******************************************************************************
// COST ITEM MODAL - STEP 1
// *******************************************************************************
// Form fields for adding/editing a cost/tax item in the supplier cost composition.
// Fields: name, percentage or value, type (application), payer source.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useMemo } from 'react';
import { Row, Col } from 'antd';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import SimpleNumber from 'components/SimpleComponents/SimpleNumber';
import SimpleCurrency from 'components/SimpleComponents/SimpleCurrency';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import SimpleSegment from 'components/SimpleComponents/SimpleSegment';
import translateX from 'utils/translateX';

// *******************************************************************************
// STEP COMPONENT
// *******************************************************************************
const Step1 = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const typeOptions = useMemo(() => [
    { value: 'informative', label: translateX('cost_type_informative') },
    { value: 'cost', label: translateX('cost_type_cost') },
    { value: 'purchaseTax', label: translateX('cost_type_purchase_tax') },
    { value: 'saleTax', label: translateX('cost_type_sale_tax') },
  ], []);

  const payerOptions = useMemo(() => [
    { value: 'municipal', label: translateX('payer_source_municipal') },
    { value: 'state', label: translateX('payer_source_state') },
    { value: 'federal', label: translateX('payer_source_federal') },
    { value: 'other', label: translateX('payer_source_other') },
  ], []);

  const modeOptions = useMemo(() => [
    { value: 'percentage', label: '%' },
    { value: 'value', label: 'R$' },
  ], []);

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Row gutter={[16, 0]}>
      <Col xs={24}>
        <SimpleInput
          name="name"
          label="cost_identification"
          required
          placeholder="FRETE, IPI, CUSTO ADM..."
        />
      </Col>

      <Col xs={24} sm={8}>
        <SimpleSegment
          name="mode"
          label="percentage_or_value"
          options={modeOptions}
        />
      </Col>

      <Col xs={24} sm={8}>
        <SimpleNumber
          name="percentage"
          label="percentage"
          min={0}
          max={100}
          decimalPlaces={3}
          percentage
        />
      </Col>

      <Col xs={24} sm={8}>
        <SimpleCurrency
          name="value"
          label="amount"
          min={0}
        />
      </Col>

      <Col xs={24} sm={12}>
        <SimpleSelect
          name="type"
          label="cost_type"
          options={typeOptions}
          required
        />
      </Col>

      <Col xs={24} sm={12}>
        <SimpleSelect
          name="payerSource"
          label="payer_source"
          options={payerOptions}
        />
      </Col>
    </Row>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default Step1;
